import { useMemo } from "react";
import { useSelectionContext } from "@/Common/context/selection/SelectionContext";
import { objectsMatchProperties } from "@/Common/helpers/objectsTs";

interface IUsePersistentSelectionArgs {
	table: string;
	commissionCycleId?: string;
	payPeriodId?: string;
}

export const usePersistentSelection = (args: IUsePersistentSelectionArgs) => {
	const { table, commissionCycleId, payPeriodId } = args;

	const {
		selectedItems,
		clearSelection,
		commissionCycleId: contextCommissionCycleId,
		payPeriodId: contextPayPeriodId,
	} = useSelectionContext();

	const usedCommissionCycleId = commissionCycleId ?? contextCommissionCycleId;
	const usedPayPeriodId = payPeriodId ?? contextPayPeriodId;

	return useMemo(
		() => ({
			selectedIds: selectedItems
				.filter((item) =>
					objectsMatchProperties(
						{
							table,
							commissionCycleId: usedCommissionCycleId,
							payPeriodId: usedPayPeriodId,
						},
						item,
						["table", "commissionCycleId", "payPeriodId"]
					)
				)
				.map((item) => item._id),
			clearSelection: () => clearSelection([{ table, commissionCycleId: usedCommissionCycleId, payPeriodId: usedPayPeriodId }]),
		}),
		[selectedItems, table, usedCommissionCycleId, usedPayPeriodId]
	);
};
